import * as React from "react";
import * as ReactDOM from "react-dom";
import { Button } from "@progress/kendo-react-buttons";
import styles from "../Settings.module.scss";
import { Grid, GridColumn as Column, GridNoRecords } from "@progress/kendo-react-grid";
import { useEffect } from "react";
import { getReportTemplates } from "api";
import * as api from "../../../api/index";
import { toast } from "react-toastify";
import {
  ActiveCell,
  EditCommandCell,
  ReportDesignerButton,
  SignatureCell,
  TemplateNameCell,
  DefaultBranchCell,
} from "../GridComponents";
import EditBillingTemplate from "./EditBillingTemplate";
import ReportDesigner from "components/ReportDesigner";
import { Dialog } from "@progress/kendo-react-dialogs";
import { GridLoader } from "components/GridLoader";

const BillingTemplates = ({ type }) => {
  const [addNewForm, setAddNewForm] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [gridLoading, setGridLoading] = React.useState(false);
  const [editItem, setEditItem] = React.useState();
  const [editReport, setEditReport] = React.useState();
  const [data, setData] = React.useState([]);
  const [dataState] = React.useState({
    take: 10,
    skip: 0,
  });

  const enterEdit = (item) => {
    setAddNewForm(true);
    setEditItem(item);
  };

  const enterReport = (item) => {
    setEditReport(item);
  };

  const getBillingTemplatesData = async () => {
    try {
      setGridLoading(true);
      const response = await getReportTemplates(type);
      const updatedData = response.data?.data.map((template) => ({
        ...template,
        symbol: template.templateName[0],
      }));
      setData(updatedData);
    } catch {
    } finally {
      setGridLoading(false);
    }
  };

  useEffect(() => {
    getBillingTemplatesData();
  }, []);

  const closeform = () => {
    if (editItem) setEditItem();
    setAddNewForm(false);
  };
  const handleSubmit = async (e) => {
    try {
      setLoading(true);
      if (editItem) {
        await api.editReportTemplate(
          {
            active: true,
            ...e,
          },
          type,
          e.reportTemplateId
        );
        toast.success("Template Updated");
        setEditItem();
      } else {
        const dataResponse = await api.addReportTemplate(
          {
            active: true,
            ...e,
            reportType: 1,
          },
          type
        );
        toast.success("Template Added");
        enterReport(dataResponse?.data?.data);
      }
      setAddNewForm(false);
      getBillingTemplatesData();
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const MyEditCommandCell = (props) => (
    <EditCommandCell {...props} enterEdit={enterEdit} />
  );

  const ReportDesignerEditCell = (props) => {
    return <ReportDesignerButton {...props} enterEdit={enterReport} />;
  };
  return (
    <div className="d-flex flex-column h-100 w-100">
      <div className="d-flex justify-content-end mb-2 flex-shrink-0">
        <Button
          className="common-btn p-2"
          style={{ minWidth: "120px" }}
          onClick={() => {
            setAddNewForm(true);
          }}
        >
          Add Template
        </Button>
      </div>

      <div className="flex-grow-1 settings-grid settings-grid-wrapper mb-2" style={{ minHeight: 0, maxWidth: "1200px" }}>
        <Grid {...dataState} data={data} style={{ height: "100%" }} showLoader={gridLoading} loader={
          <div style={{ height: "50px" }}>
            <GridLoader />
          </div>
        }>
          <GridNoRecords>
            {gridLoading ? (
              <span></span>
            ) : (
              data && data?.length === 0 && "No records available"
            )}
          </GridNoRecords>
          <Column
            title=" "
            field="symbol"
            cell={SignatureCell}
            width="80"
          />
          <Column
            field="templateName"
            title="Template Name"
            width="300px"
            cell={TemplateNameCell}
          />
          <Column
            field="defaultBranchName"
            title="Default for branch"
            width="200px"
            cell={DefaultBranchCell}
          />
          <Column cell={ActiveCell} title="Active" width="80" />
          <Column
            cell={ReportDesignerEditCell}
            title="Edit Template"
            width="125"
          />
          <Column title=" " cell={MyEditCommandCell} width="50" />
        </Grid>
      </div>
      {addNewForm && (
        <EditBillingTemplate
          cancelEdit={closeform}
          onSubmit={handleSubmit}
          isLoading={loading}
          item={editItem}
          type={editItem ? "" : "addNew"}
        />
      )}
      {editReport && (
        <Dialog
          title={"Report Designer"}
          onClose={() => {
            setEditReport(false);
          }}
          width={"100vw"}
          height={"100vh"}
          className="pt-1 ps-3 pe-3 pb-2"
        >
          <ReportDesigner reportName={editReport?.reportResourceId + ".trbp"} />
        </Dialog>
      )}
    </div>
  );
};

export default BillingTemplates;
